import "./checklist.css";
import {useEffect, useState} from "react";
import {API_URL, SOCKET} from "../../../../../../../URL";
import {CheckListItemHandleAPI} from "../../../../../../../store/api/get/CheckList/CheckListItemAPI";
import {useDispatch, useSelector} from "react-redux";
import {
    DELETE_CHECKLIST,
    DELETE_CHECKLIST_ITEM, RENAME_CHECKLIST_ITEM,
    SET_CARD_CHECKLIST,
    SET_CARD_CHECKLIST_ITEM
} from "../../../../../../../store/constants";
import {BoardListsAPI, RenameBoardListAPI} from "../../../../../../../store/api/get/Board/Board";

export const CheckLists = () => {
    const dispatch = useDispatch();
    const card = useSelector(state => state.boards.activeCard);
    const lists = useSelector((state) => state.boards.boardLists || []);
    const activeBoard = useSelector(state => state.boards.activeBoard);
    const [addingChecklistId, setAddingChecklistId] = useState(null);
    const [itemTextByChecklist, setItemTextByChecklist] = useState({});
    const [itemErrorByChecklist, setItemErrorByChecklist] = useState({});
    const [isChangeChecklistTitle, setIsChangeChecklistTitle] = useState(false);
    const [editingItemId, setEditingItemId] = useState(null);
    const [editText, setEditText] = useState("");
    const user = useSelector(state => state.user.user);

    const userRole = activeBoard?.rbac?.find(
        (el) => el.user_id === user?.id
    )?.role;

    const handleOpenAddForm = (checklistId) => {
        setAddingChecklistId(checklistId);
        setItemErrorByChecklist((prev) => ({
            ...prev,
            [checklistId]: "",
        }));
    };

    const handleCloseAddForm = () => {
        setAddingChecklistId(null);
    };

    const handleChangeItemText = (checklistId, value) => {
        setItemTextByChecklist((prev) => ({
            ...prev,
            [checklistId]: value,
        }));
        setItemErrorByChecklist((prev) => ({
            ...prev,
            [checklistId]: "",
        }));
    };

    const getErrorMessage = (error) => {
        const collectMessages = (value) => {
            if (typeof value === "string") return [value];
            if (Array.isArray(value)) return value.flatMap(collectMessages);
            if (value && typeof value === "object") {
                return Object.values(value).flatMap(collectMessages);
            }
            return [];
        };

        const messages = collectMessages(error);
        return messages.join(" ") || "Could not add the checklist item.";
    };

    const handleSaveItem = async (checklistId) => {
        const value = itemTextByChecklist[checklistId]?.trim();
        if (!value) return;

        const response = await fetch(API_URL + "/post/add_checklist_item/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                checklist_id: checklistId,
                name: value,
            }),
        });

        const data = await response.json().catch(() => null);
        if (!response.ok) {
            setItemErrorByChecklist((prev) => ({
                ...prev,
                [checklistId]: getErrorMessage(data),
            }));
            return;
        }

        dispatch({type: SET_CARD_CHECKLIST_ITEM, payload: data})
        SOCKET.emit("add_checklist_item", data);
        setItemErrorByChecklist((prev) => ({
            ...prev,
            [checklistId]: "",
        }));
        setItemTextByChecklist((prev) => ({
            ...prev,
            [checklistId]: ""
        }))
        // setAddingChecklistId(null);
    };
    useEffect(() => {
        const Checklist = (data) => {
            dispatch({
                type: SET_CARD_CHECKLIST_ITEM,
                payload: data,
            });
        };

        SOCKET.on("add_checklist_item", Checklist);

        return () => {
            SOCKET.off("add_checklist_item", Checklist);
        };
    }, [dispatch]);
    const handleChangeChecklistTitle = async (e, checklist) => {
        if (e.key === "Enter") {
            const newName = e.target.value.trim();
            setIsChangeChecklistTitle(false);

            if (newName && newName !== checklist?.title) {
                const response = await fetch(API_URL + "/post/rename_checklist/", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        id: checklist.id,
                        title: newName
                    })
                })
                const data = await response.json();

                dispatch({type: SET_CARD_CHECKLIST, payload: data});
                SOCKET.emit("rename_checklist", data)
            }
        }

        if (e.key === "Escape") {
            setIsChangeChecklistTitle(false);
        }
    }
    useEffect(() => {
        const Checklist = (data) => {
            dispatch({
                type: SET_CARD_CHECKLIST,
                payload: data,
            });
        };

        SOCKET.on("rename_checklist", Checklist);

        return () => {
            SOCKET.off("rename_checklist", Checklist);
        };
    }, [dispatch]);
    const deleteCheckList = async (id) => {
        const response = await fetch(API_URL + "/delete/delete_checklist/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({id})
        })
        const data = await response.json();
        dispatch({type: DELETE_CHECKLIST, payload: id});

        SOCKET.emit("delete_checklist", id);
    }
    useEffect(() => {
        const Checklist = (id) => {
            dispatch({
                type: DELETE_CHECKLIST,
                payload: id,
            });
        };

        SOCKET.on("delete_checklist", Checklist);

        return () => {
            SOCKET.off("delete_checklist", Checklist);
        };
    }, [dispatch]);
    const deleteCheckListItem = async (id) => {
        const response = await fetch(API_URL + "/delete/delete_checklist_item/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({id})
        })
        const data = await response.json();

        dispatch({type: DELETE_CHECKLIST_ITEM, payload: id})
        SOCKET.emit("delete_checklist_item", id)
    }
    useEffect(() => {
        const Checklist = (id) => {
            dispatch({
                type: DELETE_CHECKLIST_ITEM,
                payload: id,
            });
        };

        SOCKET.on("delete_checklist_item", Checklist);

        return () => {
            SOCKET.off("delete_checklist_item", Checklist);
        };
    }, [dispatch]);
    const editCheckListItem = (item) => {
        setEditingItemId(item.id);
        setEditText(item.name);
    };
    const handleSaveEdit = async (id) => {
        if (!editText.trim()) {
            setEditingItemId(null);
            return;
        }

        const response = await fetch(API_URL + "/post/rename_checklist_item/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                id,
                name: editText
            })
        })
        const data = await response.json();

        dispatch({type: RENAME_CHECKLIST_ITEM, payload: data});
        setEditingItemId(null);
        SOCKET.emit("rename_checklist_item", data)
    };
    useEffect(() => {
        const Checklist = (data) => {
            dispatch({
                type: RENAME_CHECKLIST_ITEM,
                payload: data,
            });
        };

        SOCKET.on("rename_checklist_item", Checklist);

        return () => {
            SOCKET.off("rename_checklist_item", Checklist);
        };
    }, [dispatch]);
    return (
        <>
            {card?.checklists?.length > 0 && (
                <div className="cardChecklist">
                    {card.checklists.map((checklist) => {
                        const total = checklist.items?.length || 0;
                        const done =
                            checklist.items?.filter((item) => item.is_checked).length || 0;
                        const percent = total ? Math.round((done / total) * 100) : 0;

                        const isAddingThisChecklist = addingChecklistId === checklist.id;
                        const itemText = itemTextByChecklist[checklist.id] || "";
                        const itemError = itemErrorByChecklist[checklist.id] || "";

                        return (
                            <div className="cardChecklist__block" key={checklist.id}>
                                <div className="cardChecklist__header">
                                    <div className="cardChecklist__titleWrap">
                                        <span className="cardChecklist__icon">☑</span>
                                        {
                                            !isChangeChecklistTitle ? (
                                                <h3 className="cardChecklist__title"
                                                    onClick={() => userRole !== 1 && setIsChangeChecklistTitle(true)}>
                                                    {checklist.title}
                                                </h3>
                                            ) : (
                                                <input
                                                    className="boardTitleInput"
                                                    type="text"
                                                    autoFocus
                                                    defaultValue={checklist?.title}
                                                    onBlur={() => userRole !== 1 && setIsChangeChecklistTitle(false)}
                                                    onKeyDown={(e) => userRole !== 1 && handleChangeChecklistTitle(e, checklist)}
                                                    style={{width: "100%"}}
                                                />
                                            )
                                        }
                                    </div>

                                    <button className="cardChecklist__deleteBtn"
                                            onClick={() => userRole !== 1 && deleteCheckList(checklist.id)}>
                                        Delete
                                    </button>
                                </div>

                                <div className="cardChecklist__progressRow">
                                    <span className="cardChecklist__percent">
                                        {percent}%
                                    </span>

                                    <div className="cardChecklist__progress">
                                        <div
                                            className="cardChecklist__progressFill"
                                            style={{width: `${percent}%`}}
                                        />
                                    </div>
                                </div>

                                {/* ✅ ITEMS LIST */}
                                {checklist?.items?.map((item) => (
                                    <div className="cardChecklist__item" key={item.id}>
                                        <div>
                                            <input
                                                type="checkbox"
                                                checked={item.is_checked}
                                                onChange={() =>
                                                    userRole !== 1 &&
                                                    dispatch(
                                                        CheckListItemHandleAPI(
                                                            item.id,
                                                            checklist.id,
                                                            !item.is_checked
                                                        )
                                                    )
                                                }
                                            />

                                            {editingItemId === item.id ? (
                                                <input
                                                    className="boardTitleInput"
                                                    value={editText}
                                                    onChange={(e) => userRole !== 1 && setEditText(e.target.value)}
                                                    onBlur={() => userRole !== 1 && handleSaveEdit(item.id)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            userRole !== 1 && handleSaveEdit(item.id);
                                                        }
                                                    }}
                                                    autoFocus
                                                />
                                            ) : (
                                                <span>{item.name}</span>
                                            )}
                                        </div>
                                        <div className="cardChecklist__item-buttons">
                                            <button
                                                className="cardChecklist__deleteBtn"
                                                onClick={() => userRole !== 1 && editCheckListItem(item)}
                                            >
                                                Edit
                                            </button>

                                            <button
                                                className="cardChecklist__deleteBtn"
                                                onClick={() => userRole !== 1 && deleteCheckListItem(item.id)}
                                            >
                                                Delete
                                            </button>
                                        </div>
                                    </div>
                                ))}

                                {/* ✅ ADD ITEM */}
                                {!isAddingThisChecklist ? (
                                    <button
                                        className="cardChecklist__addBtn"
                                        onClick={() =>
                                            userRole !== 1 && handleOpenAddForm(checklist.id)
                                        }
                                    >
                                        Add an item
                                    </button>
                                ) : (
                                    <div className="cardChecklist__addForm">
                                        <input
                                            type="text"
                                            className="cardChecklist__input"
                                            placeholder="Add an item"
                                            value={itemText}
                                            aria-invalid={Boolean(itemError)}
                                            aria-describedby={itemError ? `checklist-item-error-${checklist.id}` : undefined}
                                            onChange={(e) =>
                                                userRole !== 1 &&
                                                handleChangeItemText(
                                                    checklist.id,
                                                    e.target.value
                                                )
                                            }
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter" && userRole !== 1) {
                                                    e.preventDefault();
                                                    handleSaveItem(checklist.id);
                                                }
                                            }}
                                            autoFocus
                                        />

                                        {itemError && (
                                            <p
                                                id={`checklist-item-error-${checklist.id}`}
                                                className="cardChecklist__error"
                                                role="alert"
                                            >
                                                {itemError}
                                            </p>
                                        )}

                                        <div className="cardChecklist__actions">
                                            <button
                                                className="cardChecklist__saveBtn"
                                                onClick={() =>
                                                    userRole !== 1 &&
                                                    handleSaveItem(checklist.id)
                                                }
                                            >
                                                Add
                                            </button>

                                            <button
                                                className="cardChecklist__cancelBtn"
                                                onClick={() => {
                                                    userRole !== 1 &&
                                                    handleChangeItemText(
                                                        checklist.id,
                                                        ""
                                                    );
                                                    handleCloseAddForm();
                                                }}
                                            >
                                                ✕
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            )}
        </>
    );
};
